/**
 * /dashboard/accounting/money/payments/new — Create payment (G_ACC6c).
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/money/payments/new/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { PaymentForm } from "@/components/accounting/payment-form";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/accounting/money/payments/new",
)({
  component: NewPaymentRoute,
});

function NewPaymentRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <AccountingModuleShell
      title="New payment"
      description="Record a vendor payment with TDS support."
    >
      <PaymentForm />
    </AccountingModuleShell>
  );
}
